/**
 * Window-level pointer drag — touch-first replacement for mousemove/mouseup listeners.
 */
export function attachWindowPointerDrag(
  startEvent: React.PointerEvent,
  onMove: (clientX: number, clientY: number) => void,
  onEnd: (clientX: number, clientY: number) => void,
): void {
  const pointerId = startEvent.pointerId;
  startEvent.preventDefault();
  const target = startEvent.currentTarget as HTMLElement;
  target.setPointerCapture?.(pointerId);

  const move = (ev: PointerEvent) => {
    if (ev.pointerId !== pointerId) return;
    onMove(ev.clientX, ev.clientY);
  };

  const end = (ev: PointerEvent) => {
    if (ev.pointerId !== pointerId) return;
    window.removeEventListener('pointermove', move);
    window.removeEventListener('pointerup', end);
    window.removeEventListener('pointercancel', end);
    try {
      target.releasePointerCapture(pointerId);
    } catch {
      /* */
    }
    onEnd(ev.clientX, ev.clientY);
  };

  window.addEventListener('pointermove', move);
  window.addEventListener('pointerup', end);
  window.addEventListener('pointercancel', end);
}
